import { ReactNode } from 'react'
import sharedStyles from '../../landing-feature-store-hub.module.css'
import { Heading } from '@cinch-labs/design-system'

export interface StoreHubIntroProps {
  title: string
  body: ReactNode
}

export const StoreHubIntro = ({ title, body }: StoreHubIntroProps) => (
  <section>
    <Heading element="h2" className={sharedStyles.title}>
      {title}
    </Heading>
    <div>{body}</div>
  </section>
)
